// Models
import { CustomerFlightModel } from '../../../models/CustomerFlightModel';
import { ValidationFlightModel } from '../../../models/ValidationFlightModel';

enum claimState {
  SUBMITTED = 'Submitted',
  MORE_INFO_NEEDED = 'FlightValidationMoreInfoNeeded',
}

export type FlightModel = CustomerFlightModel | ValidationFlightModel;

const sortFlights = (a: FlightModel, b: FlightModel): number => {
  const flight_a = (a as ValidationFlightModel)?.order;
  const flight_b = (b as ValidationFlightModel)?.order;

  if (flight_a == null && flight_b == null) return 0;
  if (flight_a == null) return 1;
  if (flight_b == null) return -1;

  return flight_a - flight_b;
};

/**
 * Helper function for implementing the logic of the flight routes
 * @param claimData ({} | [])
 * @param flightType (optional) - used to display Alternative flights in Flight Itinerary screen
 * @returns Validation flights sorted by type and order if the claim has been validated; otherwise returns the Customer flights
 * NB: else statements are needed because claimData is an array on Flight Itinerary page, and an object on Claim Details page
 */
const getClaimFlightsSchedule = (
  claimData: any,
  flightType?: string
): CustomerFlightModel[] | ValidationFlightModel[] => {
  if (
    ![claimState.SUBMITTED, claimState.MORE_INFO_NEEDED].includes(
      claimData[0]?.currentState?.value
    )
  ) {
    if (flightType) {
      return claimData[0]?.claimValidationFlights
        ?.filter((flight: ValidationFlightModel) => flight?.type === flightType)
        .sort(sortFlights);
    } else {
      return claimData?.claimValidationFlights
        ?.filter((flight: ValidationFlightModel) => flight?.type === 'booked')
        .sort(sortFlights);
    }
  } else if (flightType) {
    return claimData[0]?.customerFlights?.filter(
      ({ type }: CustomerFlightModel) => type === flightType
    );
  } else {
    return claimData.customerFlights?.filter(
      ({ type }: CustomerFlightModel) => type === 'booked'
    );
  }
};

export default getClaimFlightsSchedule;
